module.exports = __webpack_public_path__ + "static/media/interface-unovatio.fdd91bf6.jpg";